<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="12">
              <h3>Update Purchase Order</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            </vs-col>
          </vs-row>

          <!-- {{  purchaseOrderDescription }} -->
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Client:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <ClientAutocomplete :key="companySearchComponentKey" class="searchbox" :list="searchCompany"
                :searchOn="'company_or_registration_no'" @event-name="selectClient"></ClientAutocomplete>

            </div>
            {{ purchaseOrderDescription.company_name }}

            <span class="text-danger text-sm mt-2">{{
              please_choose_client
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>PO Number:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="po_number" v-model="purchaseOrderDescription.po_number"
                v-validate="'required'" data-vv-as="PO Number" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('po_number')">{{ errors.first("po_number")
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Raised Date:</span>
            </div>
            <div class="vx-col sm:w-1/9">

              <datepicker v-validate="'required'" data-vv-as="Raised Date" :language="$vs.rtl ? langHe : langEn"
                name="raised_date" v-model="purchaseOrderDescription.raised_date"></datepicker>
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('raised_date')">{{ errors.first("raised_date")
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>PO Status:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">


              <v-select v-validate="'required'" required name="po_status" :options="POStatusList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="purchaseOrderDescription.po_status" data-vv-as="PO Status" />


            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('po_status')">{{ errors.first("po_status")
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>PO Value:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="total_po_value" v-model="purchaseOrderDescription.total_po_value" v-validate="'required'"
                data-vv-as="PO Value" />
            </div>
            Minimum PO Value : {{ purchaseOrderDescription.used_po_value }}
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('total_po_value')">{{ errors.first("total_po_value")
            }}</span>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>PO Allocation:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">

              <v-select disabled v-validate="'required'" required name="po_allocation" :options="POAllocation"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="purchaseOrderDescription.po_allocation"
                data-vv-as="PO Allocation" />

            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('po_allocation')">{{
              errors.first("po_allocation") }}</span>
          </div>






          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="updateForm">Submit</vs-button>
            </div>
          </div>

        </vx-card>
      </form>
    </div>


    <vs-popup title="PO Allocated Campaigns" :active.sync="showCampaignAssociatedP0">
      <vs-table stripe :data="POAssociatedCampaigns">
        <template slot="thead">
          <vs-th>Campaign Code </vs-th>
          <vs-th>Campaign Name </vs-th>
          <vs-th>Allocated Value</vs-th>
          <vs-th>Allocated On</vs-th>

        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].campaign_code">
              {{ data[indextr].campaign_code }}
            </vs-td>
            <vs-td :data="data[indextr].campaign_name">
              {{ data[indextr].campaign_name }}
            </vs-td>
            <vs-td :data="data[indextr].campaign_po_value_allocated">
              {{ data[indextr].campaign_po_value_allocated }}
            </vs-td>
            <vs-td :data="data[indextr].allocated_on">
              {{ data[indextr].allocated_on }}
            </vs-td>
       
          </vs-tr>
        </template>
      </vs-table>
  
   


    </vs-popup>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from "@/config/abilities";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import modulePurchaseOrdersManagement from "@/store/campaign-management/purchase-orders-management/modulePurchaseOrdersManagement.js";
import moduleClientsManagement from "@/store/clients-management/moduleClientsManagement.js";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import { en, he } from "vuejs-datepicker/src/locale";
import moment from "moment";
export default {
  beforeMount() {
  },
  data() {
    return {
      POAssociatedCampaigns: [],
      showCampaignAssociatedP0:false,
      langHe: he,
      langEn: en,
      POAllocation: ['Not Allocated', 'Partially Allocated', 'Fully Allocated', 'Fully Used'],
      POStatusList: [
        'Confirmed',
        'Invoiced', 'Paid'
      ],
      selected_client: null,

      companySearchComponentKey: 0,
      please_choose_client: null,
      purchaseOrderDescription: [],
      po_id: null,
      user_role: null,
      selected: [],
      allPurchaseOrders: [],
      abilities: null,
    };
  },
  components: {
    "v-select": vSelect,
    modulePurchaseOrdersManagement,
    ClientAutocomplete,
    Datepicker,
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    if (!modulePurchaseOrdersManagement.isRegistered) {
      this.$store.registerModule(
        "PurchaseOrdersManagement",
        modulePurchaseOrdersManagement
      );
      modulePurchaseOrdersManagement.isRegistered = true;
    }

    if (!moduleClientsManagement.isRegistered) {
      self.$store.registerModule("clientsManagement", moduleClientsManagement);
      moduleClientsManagement.isRegistered = true;
    }
  },
  mounted() {
    this.po_id = this.$route.params.purchaseOrderId;
    this.fetchPurchaseOrder();
  },
  watch: {

  },
  methods: {
    selectClient() {
      let self = this;
      let clients = moduleClientsManagement.state.clients.datas;
      if (clients) {
        this.selected_client = clients[0];
      }
    },
    searchCompany(inputValue) {
      this.please_choose_client = null;
      return this.$store
        .dispatch("clientsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data = moduleClientsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    goBack: function () {
      this.$router.go(-1);
    },
    updateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updatePurchaseOrders();
        }
      });
    },
    updatePurchaseOrders() {

      if(parseFloat(this.purchaseOrderDescription.total_po_value) < parseFloat(this.purchaseOrderDescription.used_po_value)){
        
        
        
        
        
        this.fetchCampaignAssociatedPO()

        this.showCampaignAssociatedP0 = true


        this.$vs.notify({
              color: "success",
              title: "Allocated PO",
              text: "PO Value should not be less than " + this.purchaseOrderDescription.used_po_value + " because it has been allocated to different campaigns."
            });
            return false

      }

      if (
        typeof this.selected_client !== "undefined" &&
        this.selected_client !== null
      ) {
        this.purchaseOrderDescription.selected_client_id = this.selected_client.id;
      } else {
        if (this.purchaseOrderDescription.selected_client_id == null) {

          this.please_choose_client = "The client field is required.";
          return false;
        }

      }


      this.purchaseOrderDescription.po_id = this.po_id

      this.$store
        .dispatch(
          "PurchaseOrdersManagement/updatePurchaseOrders",
          this.purchaseOrderDescription
        )
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Purchase Orders",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Purchase Orders",
              text: "The purchase order was updated successfully"
            });
            this.$router.push({ path: "/campaigns/purchase-orders" });
          }
        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    fetchPurchaseOrder() {
      this.$store
        .dispatch("PurchaseOrdersManagement/fetchPurchaseOrders", this.po_id)
        .then(res => {
          this.purchaseOrderDescription = JSON.parse(res.data);




          if (this.purchaseOrderDescription.client_id) {
            this.purchaseOrderDescription.selected_client_id = this.purchaseOrderDescription.client_id
          }

        })
        .catch(err => {
          console.error(err);
        });
    },
    fetchCampaignAssociatedPO() {
      this.$store
        .dispatch("PurchaseOrdersManagement/fetchCampaignAssociatedPO", this.po_id)
        .then(res => {
          this.POAssociatedCampaigns = JSON.parse(res.data);

          this.POAssociatedCampaigns.forEach(ele => ele.allocated_on = moment(ele.allocated_on).format('YYYY-MM-DD'))

          // console.log(this.POAssociatedCampaigns)
        })
        .catch(err => {
          console.error(err);
        });
    },
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
